export default __webpack_public_path__ + "static/media/N-05.4979d84f.png";